module.exports = __webpack_public_path__ + "static/media/bree-lose.001d3017.jpg";